import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import FluxContent from "./FluxPumpContent";
import FluxMixerContent from "./FluxMixerContent";
import FluxFlowMeterContent from "./FluxFlowMeterContent";

class SupplierDetails extends React.Component {
  render() {
    return (
      <div className="col-lg-8 col-md-12">
        <Switch>
          <Route path="/suppliers/flux/pumps" component={FluxContent} />
          <Route path="/suppliers/flux/mixers" component={FluxMixerContent} />
          <Route
            path="/suppliers/flux/flow-meters"
            component={FluxFlowMeterContent}
          />
          <Route path="/suppliers/flux">
            <Redirect to="/suppliers/flux/pumps" />
          </Route>
        </Switch>
      </div>
    );
  }
}

export default SupplierDetails;
